import { defineStore } from 'pinia'
import { store } from '../index'
import { UserLoginType, UserType } from '@/api/login/types'
import { ElMessageBox } from 'element-plus'
import { useI18n } from '@/hooks/web/useI18n'
import { loginOutApi } from '@/api/login'
import { useTagsViewStore } from './tagsView'
import { usePermissionStoreWithOut } from './permission'
import router from '@/router'

interface UserState {
  userInfo?: UserType
  tokenKey: string
  accessToken: string
  refreshToken: string
  roleRouters?: string[] | AppCustomRouteRecordRaw[]
  rememberMe: boolean
  loginInfo?: UserLoginType
  userData?: any
}

export const useUserStore = defineStore('user', {
  state: (): UserState => {
    return {
      userInfo: undefined,
      tokenKey: 'Authorization',
      accessToken: '',
      refreshToken: '',
      roleRouters: undefined,
      // 记住我
      rememberMe: true,
      loginInfo: undefined,
      userData: undefined,
      loginExtend: undefined
    }
  },
  getters: {
    getUserData(): any {
      return this.userData
    },
    getTokenKey(): string {
      this.tokenKey = localStorage.getItem('tokenKey')
      return this.tokenKey
    },
    getToken(): string {
      this.accessToken = localStorage.getItem('accessToken')
      return this.accessToken
    },
    getRefreshToken(): string {
      return this.refreshToken || localStorage.getItem('refreshToken')
    },
    getUserInfo(): UserType | undefined {
      return this.userInfo
    },
    getRoleRouters(): string[] | AppCustomRouteRecordRaw[] | undefined {
      return this.roleRouters
    },
    getRememberMe(): boolean {
      return this.rememberMe
    },
    getLoginInfo(): UserLoginType | undefined {
      return this.loginInfo
    },
    getLoginExtend(): any {
      return this.loginExtend
    }
  },
  actions: {
    setUserData(userData: any) {
      this.userData = userData
    },
    setTokenKey(tokenKey: string) {
      localStorage.setItem('tokenKey', tokenKey)
      this.tokenKey = tokenKey
    },
    setToken(accessToken: string) {
      localStorage.setItem('accessToken', accessToken)
      this.accessToken = accessToken
    },
    setRefreshToken(refreshToken: string) {
      this.refreshToken = refreshToken
      localStorage.setItem('refreshToken', refreshToken)
    },
    setUserInfo(userInfo?: UserType) {
      this.userInfo = userInfo
    },
    setUserLoginExtend(loginExtend?: any) {
      this.loginExtend = loginExtend
    },
    setRoleRouters(roleRouters: string[] | AppCustomRouteRecordRaw[]) {
      this.roleRouters = roleRouters
    },
    logoutConfirm() {
      const { t } = useI18n()
      ElMessageBox.confirm(t('common.loginOutMessage'), t('common.reminder'), {
        confirmButtonText: t('common.ok'),
        cancelButtonText: t('common.cancel'),
        type: 'warning'
      })
        .then(async () => {
          // const res = await loginOutApi().catch(() => {})
          // if (res) {
          //   this.reset()
          // }
          this.reset()
        })
        .catch(() => {})
    },
    reset() {
      console.log('调用重置方法')
      const tagsViewStore = useTagsViewStore()
      const permissionStore = usePermissionStoreWithOut()
      tagsViewStore.delAllViews()
      // 退出时清空动态路由缓存，避免旧菜单树（如无子菜单的 statData）残留
      permissionStore.$reset()
      permissionStore.setIsAddRouters(false)
      this.setToken('')
      this.setRefreshToken('')
      this.setUserInfo(undefined)
      this.setRoleRouters([])
      this.setLoginInfo(undefined)
      localStorage.removeItem('userInfo')
      localStorage.removeItem('accessToken')
      localStorage.removeItem('refreshToken')
      localStorage.removeItem('accountType')
      localStorage.removeItem('lastActiveAt')
      // pinia 持久化的 permission 路由（多 key 形态均清除）
      ;[
        'permission',
        'permission-routers',
        'permission-addRouters',
        'permission-menuTabRouters'
      ].forEach((key) => localStorage.removeItem(key))
      // localStorage.removeItem('user')
      // sessionStorage.clear()
      router.replace('/login')
    },
    logout() {
      console.log('调用退出缓存方法')
      this.reset()
    },
    setRememberMe(rememberMe: boolean) {
      this.rememberMe = rememberMe
    },
    setLoginInfo(loginInfo: UserLoginType | undefined) {
      this.loginInfo = loginInfo
    }
  },
  persist: true
})

export const useUserStoreWithOut = () => {
  return useUserStore(store)
}
